<script>

import { Overlay } from '../../'

export default {
    name: 'CMF',
    mixins: [Overlay],
    methods: {
        meta_info() {
            return {
                author: 'StdSquad', version: '1.0.0',
                desc: 'Chaikin Money Flow - Measures buying and selling pressure',
                preset: {
                    name: 'CMF $length',
                    side: 'offchart',
                    settings: {
                        lineWidth: 1.5,
                        color: '#9c27b0'
                    }
                }
            }
        },
        use_for() { return ['CMF'] },
        calc() {
            return {
                props: {
                    length: { def: 21, text: 'Length' }
                },
                conf: { renderer: 'Splines' },
                update: `
                    let multiplier = high[0] === low[0] ? 0 : (2 * close[0] - high[0] - low[0]) / (high[0] - low[0])
                    let flow = ts(multiplier * vol[0])
                    let total = sum(vol, length)[0]
                    return total ? sum(flow, length)[0] / total : 0
                `
            }
        }
    }
}
</script>
